import * as constants from '../constants/tags'

const defaultState = {
  tagMatrix: {},
  complianceRatings: {},
  requestType: ''
}

export default (state = defaultState, action) => {
  var newState = {...state}

  switch (action.type){
    case constants.UPDATE_TAG_REQUEST:
      newState.requestType = action.type;
      return newState;
    case constants.UPDATE_TAG_SUCCESS:
      newState.requestType = action.type;
      newState.tagMatrix.managers = action.body.managers;
      newState.tagMatrix.name = action.body.name;
      return newState;
    case constants.UPDATE_TAG_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_TAG_MATRIX_REQUEST:
      newState.requestType = action.type;
      return newState;
    case constants.GET_TAG_MATRIX_SUCCESS:
      newState.requestType = action.type;
      newState.tagMatrix = action.body;
      return newState;
    case constants.GET_TAG_MATRIX_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_COMPLIANCES_COMPARISON_REQUEST:
      newState.requestType = action.type;
      return newState;
    case constants.GET_COMPLIANCES_COMPARISON_SUCCESS:
      newState.requestType = action.type;
      newState.complianceRatings = action.body;
      return newState;
    case constants.GET_COMPLIANCES_COMPARISON_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_REQUEST:
      newState.requestType = action.type;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_SUCCESS:
      newState.requestType = action.type;
      newState.complianceRatings = action.body;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_FAILURE:
      newState = defaultState;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/v2_tags.js